import React from 'react';
import ViewAssignedProductHeader from '../ViewAssignedProductHeader';
import ViewAssignedProductContent from '../ViewAssignedProductContent';

const ViewAssignedProduct = () => {
    return (
        <>
            <ViewAssignedProductHeader />
            <ViewAssignedProductContent />
        </>
    );
};

export default ViewAssignedProduct;
